import { render, staticRenderFns } from "./sendbtn.vue?vue&type=template&id=5522549f&"
import script from "./sendbtn.vue?vue&type=script&lang=js&"
export * from "./sendbtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports